module.exports = __webpack_public_path__ + "img/stock4.27927fbe.png";